import { getAsChoices, UserRole as UserRoleEnum } from "../enums";
import {
  BooleanField,
  DateTimeField,
  EmailField,
  NumberField,
  RelationshipFieldMany,
  SelectField,
  StringField,
} from "../plugins/Cruxtify/field-types";
import {
  BooleanProperty,
  DateTimeProperty,
  EmailProperty,
  NumberProperty,
  RelationshipPropertyMany,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { ApcCrudModel } from "./ApcCrudModel";

export class User extends ApcCrudModel {
  public static icon = "mdi-account";
  protected static _typeLabel = "User";
  protected static asProperty = "user";
  public static api = {
    path: "users",
  };

  protected userIdField = ["id"];
  protected static routeBase = "users";

  public static modalEdit = true;

  protected labelGlue: string = " ";

  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.EntityOwner]: UserPermission.Edit,
      [UserRole.LoggedIn]: UserPermission.Read,
    },
    UserPermission.New
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: NumberProperty,
      opts: {
        name: "legacy_id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "name",
        label: "Name",
        sortable: true,
        rules: ["required"],
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "company",
        label: "Company",
        sortable: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "phone",
        label: "Phone Number",
      },
    },
    {
      type: EmailProperty,
      opts: {
        name: "email",
        label: "Email",
        sortable: true,
        rules: ["required"],
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "password",
        label: "Password",
        sortable: false,
      },
    },
    {
      type: BooleanProperty,
      opts: {
        name: "is_admin",
        computed: true,
      },
    },
    {
      type: BooleanProperty,
      opts: {
        name: "is_verified",
        label: "User Email Verified",
        computed: true,
        userPermissions: UserPermission.Hidden,
        // userPermissions: new UserPermissions(
        //   {
        //     [UserRole.SuperAdmin]: UserPermission.Read,
        //   },
        //   UserPermission.Hidden
        // ),
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "user_role",
        label: "Account Type",
        rules: ["required"],
        userPermissions: new UserPermissions(
          {
            [UserRole.SuperAdmin]: UserPermission.Edit,
          },
          UserPermission.Read
        ),
      },
    },
    {
      type: RelationshipPropertyMany,
      opts: {
        name: "quote_requests",
        label: "Quote Requests",
        relatedModel: "QuoteRequest",
        foreignProperty: "user",
      },
    },
  ];
  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    { type: NumberField, opts: { property: "legacy_id" } },
    { type: DateTimeField, opts: { property: "created_at" } },
    { type: DateTimeField, opts: { property: "updated_at" } },
    {
      type: SelectField,
      opts: { property: "user_role", options: getAsChoices(UserRoleEnum) },
    },
    {
      type: StringField,
      opts: { property: "name", isPrimaryLabelField: 1, cols: 6 },
    },
    {
      type: StringField,
      opts: { property: "company", cols: 6 },
    },
    { type: StringField, opts: { property: "stripe_id" } },
    {
      type: EmailField,
      opts: { property: "email", cols: 12, rules: ["email"] },
    },
    { type: BooleanField, opts: { property: "is_verified" } },
    { type: StringField, opts: { property: "password" } },
    {
      type: RelationshipFieldMany,
      opts: {
        property: "quote_requests",
        viewComponentName: "form-relationship-field-many-table",
        formComponentName: "form-relationship-field-many-table",
      },
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      id: "Crudform",
      fieldSets: [
        {
          id: "0",
          fields: ["name", "company", "email", "user_role"],
        },
        {
          id: "quotes",
          fields: ["quote_requests"],
        },
        {
          id: "meta",
          fields: ["created_at", "updated_at", "id"],
        },
      ],
    },
    {
      id: "Registration",
      fieldSets: [
        {
          id: "0",
          fields: ["name", "company", "email"],
        },
      ],
    },
    {
      id: "my-account",
      maxWidth: "600px",
      fieldSets: [
        {
          id: "0",
          fields: ["name", "company", "email"],
        },
      ],
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["created_at", "name", "company", "email", "user_role"],
      useModal: true,
      enableSearch: true,
      enableDynamicFilters: true,
      defaultSort: [
        {
          field: "created_at",
          order: "desc",
        },
      ],
    },
  ];

  public async registerUser() {
    return this.$nuxt.$api
      .POST("register", this.toApiPayload(), "")
      .then((res) => res.data);
  }

  public switchUser() {
    return this.$nuxt.$api.POST("switch-user/" + this.id);
  }

  public static endSwitchUser() {
    return this.$nuxt.$api.POST("end-switch-user");
  }
}
